import { createServerFn } from '@tanstack/react-start';
import { getRouter } from './router';

export type { RouterIds, RouterType } from './router';
export * from './utils';

export { serverRouteHandlers } from './handlers';
export { getRouter } from './router';

// Register the router instance for type safety
declare module '@tanstack/router-core' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}
declare module '@tanstack/react-router' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}

declare module '@tanstack/react-start' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}

declare module '@tanstack/router-ssr-query-core' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}

declare module '@tanstack/react-router-ssr-query' {
    interface Register {
        router: ReturnType<typeof getRouter>;
    }
}

export const getServerTime = createServerFn().handler(async () => {
    // This runs only on the server
    return new Date().toISOString();
});

// By re exporting the api from TanStack router, we can enforce that other packages
// rely on this one instead, making the type register being applied
export {
    createLazyRoute,
    ErrorComponent,
    getRouteApi,
    HeadContent,
    Link,
    Navigate,
    Outlet,
    Route,
    RouterProvider,
    Scripts,
    useLocation,
    useMatches,
    useNavigate,
    useParams,
    useRouteContext,
    useRouter,
    useRouterState,
    useSearch
} from '@tanstack/react-router';

export type { ErrorComponentProps, LinkProps, RegisteredRouter, RouteById } from '@tanstack/react-router';
export type { RouteToPath } from '@tanstack/router-core';

import type { LinkProps } from '@tanstack/react-router';
export type RouteFromPaths = LinkProps['from'];
export type RouteToPaths = LinkProps['to'];
